import React, { useState } from "react";
import styles from "../../assets/scss/TransportHandlers/TransportHandlers.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { FaEdit, FaTrash } from "react-icons/fa";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import AddTransportForm from "./AddTransportForm";
import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";
import { useDeleteTempEmployeeMutation, useGetTempEmployeesQuery } from "../../slices/admin/admin";
import { toast } from "react-toastify";
import { capitalize } from "../../utils/capitalize";

const TransportHandlers = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [editData, setEditData] = useState(null);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;

 const { data, isLoading } = useGetTempEmployeesQuery({
  offset: currentPage,
  limit,
  search,
});




  const capitalizeWords = (text) => {
    if (!text) return "";
    return text
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const [deleteTempEmployee] = useDeleteTempEmployeeMutation();

  const totalPages = data ? Math.ceil(data.total / limit) : 1;

  const handleEdit = (item) => {
    setEditData(item);
    setShowPopup(true);
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!selectedItem) return;

    try {
      await deleteTempEmployee(selectedItem._id).unwrap();

      toast.success("Temporary Employee deleted successfully");

      setDeleteModalOpen(false);
      setSelectedItem(null);

    } catch (error) {

      const errorMessage =
        error?.data?.message ||
        error?.error ||
        "Failed to delete Temporary Employee";

      toast.error(errorMessage);
    }
  };

  return (
    <div className={styles.parent}>
      <div className={styles.box}>
        <div className={styles.header}>
          <h1 className={styles.heading}>Transport & Handlers</h1>
          <button
            className={styles.addBtn}
            onClick={() => {
              setEditData(null);
              setShowPopup(true);
            }}
          >
            Add User
          </button>
        </div>

        <div className={styles.tableWrapper}>
          <input
  type="text"
  placeholder="Search by name or phone..."
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  }}
  className={styles.searchInput}
/>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>User Name</th>
                <th>Phone</th>
                <th>Designation</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="7">Loading...</td>
                </tr>
              ) : (
                data?.result?.map((item, index) => (
                  <tr key={item._id}>
                    <td>{(currentPage - 1) * limit + index + 1}</td>
                    <td>{capitalize(item.name)}</td>
                    <td>{item.phone}</td>
                    <td>{capitalize(item.empDesignation)}</td>
                    <td>
                      <span
                        className={
                          item.isActive
                            ? styles.statusActive
                            : styles.statusInactive
                        }
                      >
                        {item.isActive ? "Active" : "Inactive"}
                      </span>
                    </td>                    <td>
                      {new Date(item.createdAt).toLocaleString()}
                    </td>
                    <td>
                      <button
                        className={styles.deleteIcon}
                        onClick={() => handleEdit(item)}
                      >
                        <FaEdit />
                      </button>

                      {/* <button
                        className={styles.deleteIcon}
                        onClick={() => handleDeleteClick(item)}
                      >
                        <FaTrash />
                      </button> */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className={styles.paginationContainer}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      {showPopup && (
        <PopupWrapper onClose={() => setShowPopup(false)}>
          <AddTransportForm
            onClose={() => setShowPopup(false)}
            editData={editData}
          />
        </PopupWrapper>
      )}

      <DeleteConfirmModalLogout
        isOpen={deleteModalOpen}
        onConfirm={confirmDelete}
        onCancel={() => {
          setDeleteModalOpen(false);
          setSelectedItem(null);
        }}
        title="Are You Sure?"
        heading="Delete Temporary Employee"
        content={`Are you sure you want to delete "${selectedItem?.name}"? This action cannot be restored.`}
      />
    </div>
  );
};

export default TransportHandlers;

